// extracted by mini-css-extract-plugin
export default {"socialbtns":"footer_socialbtns__Euy1c","bgSC":"footer_bgSC__YLYS7","soLogo":"footer_soLogo__KozXj"};